import { FunctionComponent } from "react";
import { IonPage } from "@ionic/react";
import { Header } from "../modules/sites/components/header.component";
import { SiteList } from "../modules/sites/components/site-list.component";

export const SitesPage: FunctionComponent = () => (
  <IonPage>
    <Header />
    <SiteList />
  </IonPage>
);
